<template lang="html">
  <div class="move-nav" :class="{ fixed: search }">
    <div class="logo">
      <img src="../..//assets/imgs/logo.png" @click="home" />
    </div>
    <template v-if="!only">
      <div v-if="calculate && show" class="search-box">
        <Search v-show="search" ref="search" @calculateZipcode="calculateZipcode" @change="calculateZipcodeChange" />
      </div>
      <div class="user-info">
        <!--        <a class="about-us" href="/#/about">About us</a>-->
        <div class="about-us" @click="userOrder">My Orders</div>
        <span style="margin-left: 30px">
          <a class="about-us" target="_blank" href="https://support.movingkite.com/">Help Center<i-icon type="md-open" /></a>
        </span>
        <div v-if="userName" class="user-wrap">
          <i-poptip transfer trigger="hover" placement="bottom">
            <div class="user-name">
              <img class="icon-user" src="../../assets/imgs/user.png" />
              <span class="name">{{ userName }}</span>
            </div>
            <template v-slot:content>
              <i-list>
                <i-list-item class="user-pop" @click="userCenter">
                  <div class="list-item-btn" @click="userCenter">My Profile</div>
                </i-list-item>
                <i-list-item class="user-pop">
                  <div class="list-item-btn log-out" @click="logoutPage">Log out</div>
                </i-list-item>
              </i-list>
            </template>
          </i-poptip>
        </div>
        <div v-else class="btns">
          <div class="btn" @click="login">Log in</div>
          <div class="btn sign-in" @click="signup">Sign up</div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import _ from 'lodash';
import Search from './Search';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'MoveNav',
  components: {
    Search,
  },
  props: {
    autoSearchTop: Number,
    only: Boolean,
    canBack: {
      type: Boolean,
      default: true,
    },
    calculate: {
      type: Boolean,
      default: true,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      search: false,
    };
  },
  watch: {
    search: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue && this.$refs.search) {
          this.$refs.search.zipCode = this.$store.state.home.zipcode;
        } else {
          this.$emit('headerSearchHide');
        }
      }
    },
  },
  mounted() {
    if (this.$props.autoSearchTop) {
      this.search = false;
      this._handleScroll = _.throttle(this.handleScroll, 100);
      window.addEventListener('scroll', this._handleScroll);
      this._nav = document.querySelector('.move-nav');
      this._fixedHeight = this.$props.autoSearchTop;
      this.handleScroll();
    } else {
      this.search = true;
    }
  },
  methods: {
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > this._fixedHeight) {
        this.search = true;
        // this.$refs.search.zipCode = this.$store.state.home.zipcode;
      } else {
        this.search = false;
      }
    },
    userOrder() {
      if (!this.userName) {
        this.$router.push('/login');
      } else if (this.$route.name !== 'order') {
        this.$router.push('/user/order');
      }
    },
    userCenter() {
      if (this.$route.name !== 'profile') {
        this.$router.push('/user/profile');
      }
    },
    login() {
      this.$router.push('/login');
    },
    signup() {
      this.$router.push('/register');
    },
    logoutPage() {
      this.logout().then(() => {
        if (this.$route.name !== 'login') {
          this.$router.push('/');
        }
      });
    },
    home() {
      if (this.canBack) {
        this.$router.push('/');
      } else {
        this.$emit('backhome');
      }
    },
    calculateZipcode(zipcode) {
      this.$emit('goFormMap', zipcode);
      let zipreg = /^\d{5}(?:[-\s]\d{4})?$/;
      if (zipreg.test(zipcode)) {
        //原逻辑
        // this.$router.push({
        //   name: 'calculate',
        //   query: {
        //     zipcode,
        //   },
        // });
        this.$bus.$emit('headerZipcodeInput', zipcode);
      } else {
        this.$refs['search'].setError();
        this.$Message.error('invalid');
      }
    },
    calculateZipcodeChange(zipcode) {
      this.$bus.$emit('headerZipcodeChange', zipcode);
    },
    ...mapActions('login', ['logout']),
  },
  computed: mapState('app', { userName: store => store.userName }),
};
</script>
<style lang="less" scoped>
@import '../../assets/fonts/font.less';
@import '../../assets/css/main.less';
.move-nav {
  height: 86px;
  min-width: 1100px;
  background: #fff;
  padding: 0 56px;
  border-bottom: 1px solid #eeeff0;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9;
  &.fixed {
    position: fixed;
  }
  .logo {
    float: left;
    height: 100%;
    width: 200px;
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
      width: 100%;
      height: 28px;
    }
  }
  .search-box {
    margin-left: 65px;
    height: 100%;
    float: left;
  }
  .user-info {
    height: 100%;
    display: flex;
    flex-direction: row;
    float: right;
    justify-content: center;
    align-items: center;
    .about-us {
      .font-regular;
      font-size: 16px;
      font-weight: 400;
      color: @app-black-color;
      line-height: 19px;
      cursor: pointer;
    }
    .user-wrap {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-left: 30px;
      .user-name {
        .font-regular;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 16px;
        font-weight: 400;
        color: @app-black-color;
        cursor: pointer;
        text-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
        .icon-user {
          width: 16px;
          height: 18px;
        }
        .name {
          margin-left: 5px;
          color: @app-color;
        }
      }
      .logout {
        .font-light;
        cursor: pointer;
        padding-left: 10px;
        font-size: 16px;
        font-weight: 300;
        color: @app-body-color;
        line-height: 19px;
        text-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
      }
    }
    .btns {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .btn {
      .font-light;
      width: 86px;
      height: 36px;
      border-radius: 6px;
      border: 1px solid #d8dce2;
      text-align: center;
      line-height: 36px;
      margin-left: 30px;
      &.sign-in {
        background: #6e6def;
        border: none;
        margin-left: 10px;
        color: #fff;
      }
    }
  }
}
.user-pop {
  .font-light;
  padding-left: 10px;
  font-size: 16px;
  font-weight: 300;
  line-height: 19px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  .log-out {
    color: @app-body-color;
  }
  .list-item-btn {
    text-align: center;
    cursor: pointer;
    width: 100%;
    height: 100%;
  }
}
</style>
